import React from 'react';
import '../blocks/ModernBlocks.css';

const FeatureGridBlock = ({ data }) => {
  return (
    <section className="feature-grid-section">
      <div className="feature-grid-container">
        <h2 className="feature-grid-title">{data.title}</h2>
        <div className="feature-grid-layout">
          {/* Large card on the left */}
          <a href={data.items[0].link} className="feature-grid-card feature-grid-card-large">
            <img src={data.items[0].image} alt={data.items[0].label} className="feature-grid-img" />
            <span className="feature-grid-label">{data.items[0].label}</span>
            <div className="feature-grid-card-content">
              <p className="feature-grid-card-text">{data.items[0].text}</p>
              <span className="feature-grid-arrow">→</span>
            </div>
          </a>
          <div className="feature-grid-right">
            {/* Top right card */}
            <a href={data.items[1].link} className="feature-grid-card feature-grid-card-small">
              <img src={data.items[1].image} alt={data.items[1].label} className="feature-grid-img" />
              <span className="feature-grid-label">{data.items[1].label}</span>
              <div className="feature-grid-card-content">
                <p className="feature-grid-card-text">{data.items[1].text}</p>
                <span className="feature-grid-arrow">→</span>
              </div>
            </a>
            {/* Bottom right card */}
            <a href={data.items[2].link} className="feature-grid-card feature-grid-card-small">
              <img src={data.items[2].image} alt={data.items[2].label} className="feature-grid-img" />
              <span className="feature-grid-label">{data.items[2].label}</span>
              <div className="feature-grid-card-content">
                <p className="feature-grid-card-text">{data.items[2].text}</p>
                <span className="feature-grid-arrow">→</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureGridBlock; 